<template>
    <div>
        <router-view name="contractModal"></router-view>
        <v-card flat>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-btn
                    :loading="loading"
                    :disabled="loading"
                    color="purple"
                    :dark="!loading"
                    @click.prevent="loadData()"
                >
                    {{ $t('common.update') }}
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <data-table :setup.sync="dataTable"></data-table>
        </v-card>
    </div>
</template>

<script>
import API from '@/api'
import DataTable from '@/components/DataTable'

export default {
    name: 'inner-tab-demand-actives',
    components: {
        DataTable
    },
    vm: this,
    data: function (vm) {
        return {
            loading: true,
            dataTable: {
                loading: true,
                itemName: this.$t('client.contracts.dataTable.itemName'),
                headers: [
                    { text: this.$t('client.contracts.dataTable.headers.contract'), value: 'contract', width: '15%' },
                    { text: this.$t('client.contracts.dataTable.headers.typePart'), value: 'typePart', width: '15%', sortable: false },
                    { text: this.$t('client.contracts.dataTable.headers.part'), value: 'part', width: '20%', sortable: false },
                    {
                        text: this.$t('client.contracts.dataTable.headers.deadline'),
                        value: 'deadline',
                        width: '20%',
                        align: 'center',
                        sortable: false
                    },
                    {
                        text: this.$t('client.contracts.dataTable.headers.validity'),
                        value: 'validity',
                        width: '10%',
                        align: 'center',
                        date: 'iso'
                    },
                    { text: this.$t('client.contracts.dataTable.headers.status'), value: 'status', width: '10%', align: 'center' },
                    { text: this.$t('client.contracts.dataTable.headers.pendingAdditive'), value: 'pendingAdditive', width: '10%', align: 'center', sortable: false }
                ],
                items: [],
                totalItems: 0,
                requesterType: 'client',
                requesterId: undefined,
                detailTo: vm.$route.meta.detailTo,
                editTo: 'EditarContrato',
                pagination: {
                    multiSort: true,
                    mustSort: false,
                    page: 1,
                    itemsPerPage: 500,
                    groupBy: [],
                    groupDesc: [],
                    sortBy: [
                        'validity'
                    ],
                    sortDesc: [true],
                    sortFormated: [
                        { value: 'validity', descending: true }
                    ]
                },
                sortingTimeout: undefined,
                footerProps: {
                    itemsPerPageOptions: [500, 250, 100, 50, 25, 10]
                }
            }
        }
    },
    watch: {
        'dataTable.pagination.sortBy': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (this.dataTable.sortingTimeout !== undefined) clearTimeout(this.dataTable.sortingTimeout)
                    this.dataTable.sortingTimeout = setTimeout(() => {
                        let sortView = {
                            order: this.dataTable.pagination.sortFormated
                        }
                        this.$helpers.setClientSortContractActiveView(sortView)
                        this.loadData()
                    }, 1000)
                }
            },
            deep: true
        },
        'dataTable.pagination.page': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        'dataTable.pagination.itemsPerPage': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        '$route': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (window.getApp.refreshContracts) this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        if (this.$route.name === `${this.$route.meta.singleName}AbaInternaContratosAtivos`) this.loadData()
    },
    methods: {
        async loadData () {
            await this.$helpers.sleep(0)
            window.getApp.refreshContracts = false
            this.loading = true
            this.dataTable.loading = true
            this.dataTable.items = []
            this.dataTable.requesterId = this.$route.params.id
            let endpoint = API.EndPoints.getAllContract
            let sortView = JSON.parse(localStorage.getItem('clientSortContractsActives'))

            if (sortView === null) {
                sortView = {
                    order: this.dataTable.pagination.sortFormated
                }
            }

            let data = {
                client: [this.$route.params.id],
                limit: this.dataTable.pagination.itemsPerPage,
                skip: this.dataTable.pagination.page - 1,
                order: sortView.order,
                status: [ 1, 2, 3, 4 ]
            }
            new API(endpoint, data).request().then(response => {
                this.$helpers.setClientSortContractActiveView(sortView)
                this.dataTable.items = response.body.result.items
                this.dataTable.items.forEach(result => {
                    result.part = this.$helpers.formatContractPart(result.part)
                    result.deadline = this.$helpers.getContractLastDeadline(result.deadline)
                    result.status = this.$helpers.getContractStatusLabel(result.status)
                    result.pendingAdditive = (result.pendingAdditive) ? this.$t('common.yes') : this.$t('common.no')
                })
                this.dataTable.totalItems = response.body.result.count
                this.loading = false
                this.dataTable.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        }
    }
}
</script>
